import { render, staticRenderFns } from "./ClassHeader.vue?vue&type=template&id=6ef404f5&scoped=true"
import script from "./ClassHeader.vue?vue&type=script&lang=js"
export * from "./ClassHeader.vue?vue&type=script&lang=js"
import style0 from "./ClassHeader.vue?vue&type=style&index=0&id=6ef404f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef404f5",
  null
  
)

export default component.exports